import {forwardRef, InputHTMLAttributes} from "react";
import styles from "./Input.module.scss";

type TInputProps = InputHTMLAttributes<HTMLInputElement> & {
    // isLabel?: boolean;
};

export const Input = forwardRef<HTMLInputElement, TInputProps>(({...props}, ref) => {

    return (
        <input className={styles.root} ref={ref} {...props}/>
    )
})